export default "__VITE_ASSET__QWMZlQoR__"